import React from 'react';

import { useMicrosoftUET, useMetaPixel } from '../../../../hooks';

const MedicinalCannabisForm = React.lazy(
  () => import('../../../../components/form/standard-forms/medicinal-cannabis-form'),
);

export const MedicinalCannabisFormRoute = () => {
  useMicrosoftUET();
  useMetaPixel('alternative-therapy-form');

  return <MedicinalCannabisForm />;
};
